export default {
  prev: 'prev',
  next: 'next',
};
